class costCenters {
  constructor(rolId, id, name) {
    this.rolId = rolId
    this.id = id
    this.name = name;
  }
  static fromJson({ rolId, csCostoId, nomCsCosto }) {
    return new costCenters(rolId, csCostoId, nomCsCosto);
  }
}
export default costCenters


